module.exports = __webpack_public_path__ + "static/media/3.066239f3.jpg";